import CommonHelmet from '@src/components/CommonHelmet';
import RegistrationComplete from '@src/features/company/company-user/RegistrationComplete';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';

function CompanyRegistrationComplete() {
  return (
    <CompanyCenterCardLayout showCommonComponents={true}>
      <CommonHelmet />
      <RegistrationComplete />
    </CompanyCenterCardLayout>
  );
}

export default CompanyRegistrationComplete;
